import { render, staticRenderFns } from "./PocilyStatementPage.vue?vue&type=template&id=40bdd7fc&scoped=true&"
import script from "./PocilyStatementPage.vue?vue&type=script&lang=js&"
export * from "./PocilyStatementPage.vue?vue&type=script&lang=js&"
import style0 from "./PocilyStatementPage.vue?vue&type=style&index=0&id=40bdd7fc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bdd7fc",
  null
  
)

export default component.exports